/* Menu: stop swipes on horizontally scrolling rows (like Free tools) from closing the menu. */
(function(){
var blocked=false;
function scrollable(el){
  while(el&&el!==document.body&&el!==document.documentElement){
    if(el.nodeType===1){
      var s=getComputedStyle(el);
      if((s.overflowX==='auto'||s.overflowX==='scroll')&&el.scrollWidth>el.clientWidth+2)return true;
    }
    el=el.parentNode;
  }
  return false;
}
document.addEventListener('touchstart',function(e){
  var t=e.target;
  blocked=!!(t&&t.closest&&t.closest('.mk-nav')&&scrollable(t));
  if(blocked)e.stopPropagation();
},{capture:true,passive:true});
document.addEventListener('touchend',function(e){
  if(blocked){e.stopPropagation();blocked=false;}
},{capture:true,passive:true});
document.addEventListener('touchcancel',function(){blocked=false;},{capture:true,passive:true});
})();